import { schoolYearsData } from './schoolYearsData.js';
import { appointedYears } from './appointedYearsData.js';

export const occupationalTherapistData = [
    {
        id: 'hello-there',
        jobTitle: 'occupational-therapist',
        components: [
            {
                type: "Title",
                content: "Hello, there!"
            },
            {
                type: "Sub Title",
                content: "There are <strong>three factors</strong> that influence your pay:"
            },
            {
                type: "Content Box",
                title: "Educational Differentials",
                textAlign: "left",
                icon: "college-credits",
                content: [
                    {
                        content: 'College Degree',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Experience Differentials",
                textAlign: "left",
                icon: "teach-exp",
                content: [
                    {
                        content: 'Work Experience',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Longevities",
                textAlign: "left",
                icon: "employment-length",
                content: [
                    {
                        content: 'Length of Employment',
                    },
                ]
            },
            {
                type: "Content",
                content: "We're going to check each one for errors."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Get started", 
                        linkId: "educational-differentials",
                    }
                ]
            }
        ]
    },
    {
        id: 'educational-differentials',
        jobTitle: 'occupational-therapist',
        stepNumber: 1,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/college-credits-dark-green.png"),
                alt: "Graudation Cap Icon",
                width: "98px"
            },
            {
                type: "Title",
                content: "Educational Differentials"
            },
            {
                type: "Content",
                content: "Occupational Therapists can cash in on a regionally accredited college/university degree for higher pay through an educational differential."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "do-you-have-a-masters-degree",
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-have-a-masters-degree',
        jobTitle: 'occupational-therapist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Do you have a <br/>master's degree?"
            },
            {
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "masters-differential"
                    },
                    {   
                        question: "No",
                        value: "pass",
                        answerId: "base-differential"
                    }
                ]
            }
        ]
    },
    {
        id: 'masters-differential',
        jobTitle: 'occupational-therapist',
        stepNumber: 1,
        components: [
            {
                type:"Title",
                content: "Congrats!"
            },
            {
                type: "Content",
                content: "You have earned an educational differential."
            },
            {
                type: 'Differentials',
                content: [
                    {   
                        dollarSign: "$$",
                        title: "",
                        content: "Masters Differential",
                        nickname: "",
                    },
                    {
                        dollarSign: "$",
                        title: "",
                        content: "Base Salary",
                        nickname: "",
                        qualify: false
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "therapist-experience",
                        variableId: "degree-type",
                    }
                ]
            }
        ]
    },
    {
        id: 'base-differential',
        jobTitle: 'occupational-therapist',
        stepNumber: 1,
        components: [
            {
                type:"Title",
                content: "Okay!"
            },
            {
                type: "Content",
                content: "You should be earning the base salary."
            },
            {
                type: 'Differentials',
                content: [
                    {   
                        dollarSign: "$$",
                        title: "",
                        content: "Masters Differential",
                        nickname: "",
                        qualify: false
                    },
                    {
                        dollarSign: "$",
                        title: "",
                        content: "Base Salary",
                        nickname: ""
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "therapist-experience",
                        variableId: "degree-type"
                    }
                ]
            }
        ]
    },
    {
        id: "therapist-experience",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/teaching-exp-green.png"),
                width: "64px"
            },
            {
                type: "Title",
                content: "Occupational Therapist Experience"
            },
            {
                type: "Content",
                content: "After two years of experience, Occupational Therapists become Senior Occupational Therapists (and earn a pay increase). Senior Occupational Therapists then earn extra pay called Experience Differentials after three, five and ten years of service."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you hired as a Occupational Therapist by the NYC DOE?"
            },
            ...schoolYearsData,
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "way-to-go",
                            "did-you-submit-a-voe",
                        ],
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "way-to-go",
                            "did-you-submit-a-voe",
                        ],
                        hidden: true,
                        variableId: [
                            "appointed-month",
                            "appointed-day",
                            "appointed-year"
                        ]
                    }
                ]
            },
        ]
    },
    {
        id: "did-you-submit-a-voe",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Did you submit a VOE (verification of employment letter) to your supervisor for prior experience?"
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "how-much-salary-step-credit",
                    },
                    {   
                        question: "No",
                        answerId: "estimated-salary-step-schedule",
                    }
                ]
            }
        ]
    },
    {
        id: "how-much-salary-step-credit",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "How much prior experience were you granted"
            },
            {
                type: "Dropdown",
                id: "term-length",
                content: [
                    {
                        label: "Years",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1 Year",
                        value: "1"
                    },
                    {
                        label: "2 Years",
                        value: "2"
                    },
                    {
                        label: "3 Years",
                        value: "3"
                    },
                    {
                        label: "4 Years",
                        value: "4"
                    },
                    {
                        label: "5 Years",
                        value: "5"
                    },
                    {
                        label: "6 Years",
                        value: "6"
                    },
                    {
                        label: "7 Years",
                        value: "7"
                    },
                    {
                        label: "8 Years",
                        value: "8"
                    },
                    {
                        label: "9 Years",
                        value: "9"
                    },
                    {
                        label: "10 Years",
                        value: "10"
                    },
                    {
                        label: "11 Years",
                        value: "11"
                    },
                    {
                        label: "12 + Years",
                        value: "12"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "way-to-go",
                            "estimated-salary-step-schedule"
                        ],
                        hidden: true,
                        variableId: "term-length"
                    }
                ]
            }
            
        ]
    },
    {
        id: "estimated-salary-step-schedule",
        jobTitle: 'occupational-therapist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Here's your experience differential forecast."
            },
            {
                type: "Modal",
                label: 'How accurate is this?',
                title: "How accurate is this?",
                content: [
                    {
                        type: "Content",
                        content: "This estimate of your experience differential schedule assumes you will remain on NYC DOE payroll during this entire period and will have satisfactory evaluations each year.",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "Events that can affect your experience differential progress:",
                        listItems:[
                            "Unpaid leaves*",
                            "Overall unsatisfactory or ineffective rating"
                        ],
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "*You must reapply for your experience differential credit when returning to NYC DOE payroll",
                        textAlign: "left",
                        textSize: "small"
                    }
                ]
            },
            {
                type: 'Salary Schedule'
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        value: "pass",
                        linkId: "longevities"
                    }
                ]
            }
        ]
    },
    {
        id: "way-to-go",
        jobTitle: 'occupational-therapist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Way to go!",
                underline: true
            },
            {
                type: "Title",
                content: "You've reached the highest experience differential."
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        linkId: "longevities",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "longevities",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/length-of-employment-green.png"),
                alt: "Length of Emplpoyment Icon",
                width: "65px"
            },
            {
                type: "Title",
                content: "Longevities"
            },
            {
                type: "Content",
                content: "Occupational Therapists get additional salary increases on eight key milestones: 1, 2, 5, 7, 10, 15, 20 and 22 years of service within NYC public schools. These increases, called longevities, add thousands to your salary—and your pension. Let’s see when you can celebrate."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "correct-apponted-date"
                    }
                ]
            }
        ]
    },
    {
        id: "correct-apponted-date",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Appointed Date",
                content: "You told us you were hired as a Occupational Therapist by the NYC DOE on",
            },
            {
                type: "Sub Title",
                content: "Is this correct?"
            },
            {   
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                    },
                    {   
                        question: "No",
                        answerId: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever been off NYC DOE payroll for more than 30 days?"
            },
            {   
                type: 'Question',
                id: "step-3-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "off-doe-payroll-for-more-than-30-days"
                    },
                    {   
                        question: "No",
                        answerId: [
                            "no-longevity-increase",
                            "highest-longevity",
                            "longevity-increase"
                        ],
                        variableId: "appointed-date"
                    }
                ]
            }
        ]
    },
    {
        id: "off-doe-payroll-for-more-than-30-days",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Being off NYC DOE payroll for more than 30 days may impact your longevity schedule."
            },
            {
                type: "Content",
                content: "We recommend that you call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> to confirm your information."
            },
            {   
                type: 'Button',
                content: [
                    {
                        label: "Continue to Final Review",
                        linkStyle: true,
                        linkId: "final-review"
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed by the NYC DOE in your current title?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-longevity",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed-longevity",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        id: "no-longevity-increase",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Keep going!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See all of your longevity increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "highest-longevity",
        jobTitle: 'occupational-therapist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "You are amazing!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your base salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "Go to final review",
                        linkId: "final-review",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-increase",
        jobTitle: 'occupational-therapist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Congrats!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your annual salary."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See your next increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-schedule",
        jobTitle: 'occupational-therapist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Here are your forecasted longevity dates."
            },
            {
                type: 'Modal',
                label: 'When will I see my pay increase?',
                title: "When will my longevity increase show up in my paycheck?",
                content: [
                    {
                        type: "Content",
                        content: "Longevity increases should be reflected in 1&ndash;2 pay periods following your eligibility date and will include any retroactive pay if applicable.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Longevity Schedule"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "final-review",
                    }
                ]
            }
        ]
    },
    {
        id: "final-review",
        jobTitle: 'occupational-therapist',
        background: [
            {
                color: "#17724D",
            }
        ],
        stepNumber: 4,
        components: [
            {
                type: "Title",
                content: "Final Review",
            },
            {
                type: "Sub Title",
                content: "We checked three aspects of your pay for errors."
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Content Box",
                title: "Educational Differentials",
                textAlign: "left",
                errorCheck: "step-1-status",
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Differential Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, we believe you should have this differential:",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "differential"
                            },
                            {
                                type: "Content",
                                content: "Most differential errors are a result of applying for the wrong differential or failing to apply for a differential altogether.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Report Error Online",
                                link: "https://hub.uft.org/uftselfservice/s/salary-inquiry-form",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Apply for a Differential",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Experience Differentials",
                textAlign: "left",
                errorCheck: "step-2-status",
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Salary Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, we believe you should be on experience differential:",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "salary step"
                            },
                            {
                                type: "Content",
                                content: "Most experience differential errors are caused by one of two things: forgetting to resubmit a experience differential application after being off NYC DOE payroll for more than 30 days, or failing to submit information about qualifying work experience when initially hired.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Report Error Online",
                                link: "https://hub.uft.org/uftselfservice/s/salary-inquiry-form",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Resubmit a Salary Step Application",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Longevities",
                textAlign: "left",
                errorCheck: "step-3-status",
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Longevity Issue"
                            },
                            {
                                type: "Content",
                                content: "Because you were off NYC DOE payroll for 30 or more days, we recommend that you call a UFT Salary Specialist to ensure your longevity schedule is correct.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Salary Schedule Codes",
                title: "Your estimated salary:",
                content: [
                    {
                        type: "Content",
                        content: "This information is based on the answers you provided while using this calculator. If you believe you have an error with your pay, please contact a UFT Salary Specialist at 212-331-6311."
                    },
                    {
                        type: "External Link",
                        label: "Open Occupational Therapist Salary Schedule",
                        link: "https://www.uft.org/your-rights/salary/doe-and-city-salary-schedules/otsalary-schedule"
                    }
                ],
                 modal:[
                    {
                        label: 'Use this calculator',
                        title: "Adult Education Teacher Salary Converter",
                        content: [
                            {
                                type: "Salary Calculator"
                            }
                        ]
                    }
                ]
            },
            {
                type: "Salary Schedule",
                title: "Upcoming salary changes:",
                longevity: true
            }
        ]
    }
]